module.exports = "info-message"